// extracted by mini-css-extract-plugin
export default {"listItemCross":"ListItemCross_listItemCross__f3tZE","listItemCrossIcon":"ListItemCross_listItemCrossIcon__bAGhi"};